import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { SideMenuComponentBox } from "../../../side-menu/boxes/side-menu-component.box";
import {hexToRgba} from "../../../../themes/hex-to-rgba";

const SideMenuListDefaultBox = styled(SideMenuComponentBox)`
    margin: 1rem 0 0 0;
    padding: 0;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
        margin: 1rem 0 0 0;
    }
`;

const SideMenuListCasino777Box = styled(SideMenuListDefaultBox)`
    padding: 1rem 0;
`;

const SideMenuListHarrahsWsopBox = styled(SideMenuListDefaultBox)`
    margin: 2rem 0 0 0;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
        margin: 1rem 0 0 0;
    }
`;

const SideMenuListMrGreenBox = styled(SideMenuListDefaultBox)`
    border-bottom: 1px solid ${({theme}) => hexToRgba(theme.colors.boxBorderLighter, 0.2)};
    border-radius: 0;

    &:last-child {
        border-bottom: none;
    }
`;

export const SideMenuListBox = styledByTheme(SideMenuListDefaultBox)
    .forCasino777(SideMenuListCasino777Box)
    .forHarrahs(SideMenuListHarrahsWsopBox)
    .forWsop(SideMenuListHarrahsWsopBox)
    .forMrGreen(SideMenuListMrGreenBox)
    .apply();
